module.exports = __webpack_public_path__ + "static/media/iconfinder_b-27_4229861.f3038b14.svg";